import { render, staticRenderFns } from "./playerResults.vue?vue&type=template&id=872c3f0c&scoped=true"
import script from "./playerResults.vue?vue&type=script&lang=js"
export * from "./playerResults.vue?vue&type=script&lang=js"
import style0 from "./playerResults.vue?vue&type=style&index=0&id=872c3f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872c3f0c",
  null
  
)

export default component.exports